import { Injectable } from '@angular/core';
import { TaxVoucher, TaxVoucherCreationParams, TaxVoucherSummary } from '@pedix-workspace/utils';

export type TaxVoucherInput = TaxVoucher | TaxVoucherSummary;

@Injectable({ providedIn: 'root' })
export abstract class TaxVoucherActionsService {
  abstract getPdfUrl(taxVoucherInput: TaxVoucherInput): string;

  abstract onPrintTaxVoucherTicket(taxVoucherInput: TaxVoucherInput): Promise<void>;
  abstract onGenerateTaxVoucher(
    params: TaxVoucherCreationParams,
  ): Promise<TaxVoucherSummary | null>;
  abstract onGenerateCreditNote(
    taxVoucherInput: TaxVoucherInput,
  ): Promise<TaxVoucherSummary | null>;
  
  abstract onSendTaxVoucherEmail(
    taxVoucherInput: TaxVoucherInput,
  ): Promise<void>;
}
